1<template>
  <div class="fRow jBetween aStart fullWidth wrap fileUploader">
    <h4 class="fullWidth">فایل مورد نظر را آپلود کنید</h4>
    <upload-item v-for="(item, index) in uploaders" v-bind:key="index"
      @delete="d($event)"
      @uploadComplete="uploadComplete($event)"
      :uploaderId="item"
      :cId="courseId"
      :index="index + 1"/>
    <div class="b fRow jCenter aCenter" @click="newUploader">
      <i class="material-icons-round">add</i>
      <label>برای اضافه کردن فایل اینجا کلیک کنید</label>
    </div>
    <div class="Uploadeds fRow jBetween aStart fullWidth wrap" v-if="uploaded.length > 0">
      <h5 class="fullWidth">لیست فایل‌های آپلود شده برای این کلاس: {{uploaded.length}} مورد</h5>
      <div class="fRow jBetween aStart fullWidth wrap">
        <div class="uploadedItem fRow jBetween aCenter w50"
          v-for="(item, index) in uploaded" v-bind:key="index">
          <div class="infos fCol jCenter aStart">
            <div class="fTitle">{{index + 1}} - {{item.label}}</div>
            <span>نوع فایل: {{item.type}}  -  حجم: {{item.size}}</span>
          </div>
          <div class="b f fRow jStart aCenter red" @click="deleteItem(item.url)">
            <i class="material-icons-round">delete</i>
          </div>
        </div>
      </div>
      <div class="b fRow jStart aCenter big active" @click="submitFiles">
        <i class="material-icons-round">done_all</i>
        <label>ثبت فایلهای آپلود شده</label>
      </div>
    </div>
  </div>
</template>

<script>
import UploadItem from '@/components/UploadItem.vue';
import axios from 'axios';
// eslint-disable-next-line
import { EventBus } from '@/mixins/event-bus.js';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';

export default {
  props: ['courseId'],
  mixins: [errorHandler, makeToast],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      uploaders: [],
      isUploading: false,
      uploaded: [],
      uploadedJustPath: [],
      uploadedFilesArray: [],
    };
  },
  watch: {
    uploaders() {
      this.$emit('activeUploaders', this.uploaders.length);
    },
    uploaded() {
      this.$emit('uploaded', this.uploaded);
      this.uploadedFilesArray = [];
      for (let i = 0; i < this.uploaded.length; i += 1) {
        let u = this.uploaded[i].url.split('/');
        [u] = [u[1].split('.')[0]];
        const a = {
          fileId: u,
          name: this.uploaded[i].label,
        };
        this.uploadedFilesArray.push(a);
      }
      // console.log(this.uploaded);
      // console.log(this.uploadedFilesArray);
    },
  },
  methods: {
    newUploader() {
      const r = Math.floor(Math.random() * 100) + Math.floor(Math.random() * 100) * 1000;
      this.uploaders.push(r);
      // console.log(this.uploaders);
    },
    submitFiles() {
      const reqUrl = `${this.baseURL}/api/v${this.V}/Courses/files/${this.courseId}`;
      axios({
        method: 'put',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        data: {
          files: this.uploadedFilesArray,
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.uploaded = [];
          this.$emit('refreshFiles');
          this.makeToast('success', 'فایلهای دوره با موفقیت ثبت شدند', 3000);
        } else {
          // alert('something wrong');
          this.makeToast('warning', 'مشکلی در ثبت فایلها پیش آمده است.', 3000);
        }
      }, (error) => {
        // console.log(error);
        this.makeToast('error', this.errorHandler(error), 3000);
      });
    },
    deleteItem(item) {
      // console.clear();
      // console.warn(item);
      // console.error(this.uploaded);
      const i = this.uploaded.indexOf(item);
      // console.warn(i);
      this.uploaded.splice(i, 1);
      // console.error(this.uploaded);
    },
    d(e) {
      // console.log(e);
      const i = this.uploaders.indexOf(e);
      this.uploaders.splice(i, 1);
      // console.warn(this.uploaders);
    },
    uploadComplete(e) {
      this.uploaded.push(e);
    },
    clearUploaded() {
      this.uploaded = [];
    },
  },
  components: {
    UploadItem,
  },
  mounted() {
    EventBus.$on('resetUploaded', () => {
      this.uploaded = [];
      this.uploaders = [];
    });
    EventBus.$on('setUploaded', (payload) => {
      this.uploaders = [];
      this.uploaded = payload;
    });
  },
};
</script>

<style lang="scss" scoped>
$azadSecondary: #8e9bd6;
$azadPrimary: #2156ae;
$azadNormalText: #343434;
$azadDarkText: #131313;
$azadInvertText: #fafafa;
$azadError: rgb(194, 34, 34);
.fileUploader {
  margin-bottom: 16px;
  h4 {
    margin: 0;
    padding: 0;
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 200;
    text-align: right;
    padding-right: 8px;
    border-right: 4px solid rgba($color: #000000, $alpha: 0.25);
  }
  h5 {
    margin: 0;
    padding: 0;
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 300;
    text-align: right;
    padding-right: 16px;
    border-right: 4px solid rgba($color: #000000, $alpha: 0.25);
  }
  .addBox {
    border-radius: 8px;
    padding: 8px 16px;
    background-color: $azadPrimary;
    cursor: pointer;
    i {
      color: rgba($color: #ffffff, $alpha: 0.75);
      margin-left: 8px;
    }
    label {
      font-size: 14px;
      color: rgba($color: #ffffff, $alpha: 1);
    }
  }
  .Uploadeds {
    padding: 16px;
    border-radius: 8px;
    margin-top: 16px;
    box-shadow: 0 0 16px 0 rgba($color: #000000, $alpha: 0.05),
      0 4px 4px 0 rgba($color: #000000, $alpha: 0.15);
    .uploadedItem {
      padding: 8px;
      margin-bottom: 8px;
      border-radius: 8px;
      box-shadow: 0 0 16px 0 rgba($color: #000000, $alpha: 0.05),
        0 4px 4px 0 rgba($color: #000000, $alpha: 0.15);
      .fTitle {
        font-size: 14px;
        font-weight: 300;
        padding-right: 8px;
        text-align: right;
      }
      span {
        font-size: 12px;
        font-weight: 100;
        padding-right: 8px;
        text-align: right;
        color: $azadPrimary;
      }
      .red {
        margin: 0;
        background-color: red !important;
        i {
          color: white !important;
        }
      }
    }
  }
}
</style>
